import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'

import failedImg from '../../../assets/admissionexam-failed.svg'
import completedImg from '../../../assets/completed.svg'
import { Icons } from '../../../utils/utilities'
import { useLocation } from 'react-router-dom'

export default function AlreadyAttempted ( { handleReattemptRequest, processing = false } ) {

    const { t } = useTranslation()
    const { pathname } = useLocation()

    const thankyouPage = useMemo( () => pathname.match( /(thankyou)\/?$/ ), [pathname] )

    return (
        <Box component={Paper} sx={{ flexShrink: 0, borderRadius: "10px", padding: "20px", maxWidth: "400px" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }} >

                <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }} >
                    <Box component="img" src={thankyouPage ? failedImg : completedImg} width={thankyouPage ? "170px" : "200px"} alt="Attempt already made" />
                    <Typography variant='h6' lineHeight={1.2} textAlign="center" sx={{ fontSize: thankyouPage ? "1.3rem" : "1.6rem" }}>{thankyouPage ? t( 'thankYou.examFailed' ) : t( 'candidateLogin.alreadyAttemptedHeader' )}</Typography>
                    <Typography variant='subtitle2' textAlign="center" color='textSecondary' sx={{ fontSize: "0.875rem" }}>{thankyouPage ? t( 'thankYou.reattemptInfo' ) : t( 'candidateLogin.alreadyAttemptedSubHeader' )}</Typography>
                </Box>

                <Box>
                    <Button type='button' onClick={handleReattemptRequest} sx={{ mt: 2, textTransform: "capitalize", py: 1, px: 2 }} disableElevation startIcon={processing ? <CircularProgress size={14} /> : Icons.default.Replay} disabled={Boolean( processing )} size='small' variant='contained' >{processing ? t( 'candidateLogin.requestingRetry' ) : t( 'candidateLogin.requestRetry' )}</Button>
                </Box>
            </Box>
        </Box>
    )
}
